var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimReorderVolume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 18.43c-.917 0-1.658.75-1.658 1.666 0 .917.741 1.667 1.658 1.667.917 0 1.667-.75 1.667-1.667s-.75-1.667-1.667-1.667Zm-5-12.5c0 .458.375.833.833.833h.834l3 6.325-1.125 2.033c-.609 1.117.191 2.475 1.458 2.475h9.167a.836.836 0 0 0 .833-.833.836.836 0 0 0-.833-.834H5.5l.917-1.666h6.208c.625 0 1.175-.342 1.458-.859l2.984-5.408a.83.83 0 0 0-.725-1.233H4.008L3.45 5.57a.827.827 0 0 0-.75-.475H1.333a.836.836 0 0 0-.833.833Zm13.333 12.5c-.916 0-1.658.75-1.658 1.666 0 .917.742 1.667 1.658 1.667.917 0 1.667-.75 1.667-1.667s-.75-1.667-1.667-1.667Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    d: "m15.734.501-.31.001a6.383 6.383 0 0 0-4.227 1.764C10.09 3.323 9.384 4.762 9.34 6.328c-.049 1.696.638 3.24 1.78 4.36a6.388 6.388 0 0 0 4.485 1.812 6.4 6.4 0 0 0 3.836-1.261c.276-.207.42-.507.438-.814a1.11 1.11 0 0 0-.338-.86c-2.036.379-2.948.713-3.936.713a4.077 4.077 0 0 1-2.844-1.133 3.674 3.674 0 0 1-1.14-2.698c.014-1.001.467-1.92 1.173-2.594a4.075 4.075 0 0 1 2.753-1.129A4.094 4.094 0 0 1 18.41 3.82 3.696 3.696 0 0 1 19.553 6h-1.58l2.414 3.444 3.371-2.573-1.9-.72c-.093-1.552-.8-2.946-1.897-3.963A6.405 6.405 0 0 0 15.424.502Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimReorderVolume);
export default __webpack_public_path__ + "static/media/SimReorderVolume.417002e0d1f383d2fcd683d3f7d6e6b6.svg";
export { ForwardRef as ReactComponent };